<main>
  <p-toast></p-toast>

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'Reporting_Page_Title' | translateWF: 'Inventory Reports' }}</h1>
      </div>
    </div>

    <!-- Panel 1: Export -->
    <p-panel [header]="'Export'" [toggleable]="true" *ngIf="isAdmin">
      <div class="col-sm">
        <!-- Monthly Billing Report (Admin only - contains pricing data) -->
        <p-panel data-tone="surface" [header]="'Reporting_Monthly_Billing_Title' | translateWF: 'Monthly Billing'">
          <ng-template pTemplate="icons">
            <p-button
              [label]="'Reporting_Generate_Report' | translateWF: 'Generate Report'"
              icon="pi pi-download"
              (onClick)="generateMonthlyBillingReport()"
              [outlined]="true"
              [loading]="loadingMonthlyBilling()"
              [disabled]="!monthlyBillingForm.valid || isAnyReportLoading()"
            />
          </ng-template>
          <p-card data-variant="flat">
            <p class="report-description">
              {{
                'Reporting_Monthly_Billing_Description'
                  | translateWF
                    : 'Generate monthly billing report summarizing invoiced dispatches by fabric and color within a date range
              (max 60 days)'
              }}
            </p>
            <form [formGroup]="monthlyBillingForm" class="report-form col">
              <div class="grid-12-sm">
                <div class="span-12-6-3 form-box">
                  <label for="monthly-billing-start">{{ 'Reporting_Start_Date' | translateWF: 'Start Date' }} *</label>
                  <p-datepicker
                    id="monthly-billing-start"
                    formControlName="startDate"
                    [iconDisplay]="'input'"
                    [showIcon]="true"
                    dateFormat="yy-mm-dd"
                    fluid
                    class="w-full"
                    [ngClass]="{
                      'ng-invalid ng-dirty': monthlyBillingForm.get('startDate')?.invalid && monthlyBillingForm.get('startDate')?.touched,
                    }"
                  />
                  <small class="p-error" *ngIf="monthlyBillingForm.get('startDate')?.invalid && monthlyBillingForm.get('startDate')?.touched">
                    {{ 'Reporting_Start_Date_Required' | translateWF: 'Start date is required' }}
                  </small>
                </div>

                <div class="span-12-6-3 form-box">
                  <label for="monthly-billing-end">{{ 'Reporting_End_Date' | translateWF: 'End Date' }} *</label>
                  <p-datepicker
                    id="monthly-billing-end"
                    formControlName="endDate"
                    [iconDisplay]="'input'"
                    [showIcon]="true"
                    dateFormat="yy-mm-dd"
                    [maxDate]="monthlyBillingMaxDate()"
                    fluid
                    class="w-full"
                    [ngClass]="{
                      'ng-invalid ng-dirty': monthlyBillingForm.get('endDate')?.invalid && monthlyBillingForm.get('endDate')?.touched,
                    }"
                  />
                  <small class="p-error" *ngIf="monthlyBillingForm.get('endDate')?.invalid && monthlyBillingForm.get('endDate')?.touched">
                    {{ 'Reporting_End_Date_Required' | translateWF: 'End date is required' }}
                  </small>
                </div>
              </div>
              <div class="report-options mb-4" *ngIf="isAdmin">
                <div class="option-toggle">
                  <p-toggle-switch inputId="monthly-billing-prices" formControlName="includePrices" />
                  <label for="monthly-billing-prices">
                    {{ 'Reporting_Include_Prices' | translateWF: 'Include Prices' }}:
                    <strong>{{
                      monthlyBillingForm.value.includePrices ? ('Reporting_With_Prices' | translateWF: 'With Prices') : ('Reporting_Without_Prices' | translateWF: 'Without Prices')
                    }}</strong>
                  </label>
                </div>
              </div>
            </form>
          </p-card>
        </p-panel>
      </div>
    </p-panel>

    <!-- Panel 2: Knitting -->
    <p-panel [header]="'Knitting'" [toggleable]="true">
      <div class="col-sm">
        <!-- Report 1: Knitting Current Balance -->
        <p-panel data-tone="surface" [header]="'Reporting_Knitting_Balance_Title' | translateWF: 'Knitting Current Balance'">
          <ng-template pTemplate="icons">
            <p-button
              [label]="'Reporting_Generate_Report' | translateWF: 'Generate Report'"
              icon="pi pi-download"
              (onClick)="generateKnittingBalanceReport()"
              [outlined]="true"
              [loading]="loadingKnittingBalance()"
              [disabled]="isAnyReportLoading()"
            />
          </ng-template>
          <p-card data-variant="flat">
            <p class="report-description">
              {{
                'Reporting_Knitting_Balance_Description'
                  | translateWF
                    : 'Generate current inventory balance report for
              knitting operations'
              }}
            </p>
            <form [formGroup]="knittingBalanceForm" class="report-form">
              <div class="report-options" *ngIf="isAdmin">
                <div class="option-toggle">
                  <p-toggle-switch inputId="knitting-balance-costs" formControlName="includeCosts" />
                  <label for="knitting-balance-costs">
                    {{ 'Reporting_Include_Costs' | translateWF: 'Include Costs' }}:
                    <strong>{{
                      knittingBalanceForm.value.includeCosts ? ('Reporting_With_Costs' | translateWF: 'With Costs') : ('Reporting_Without_Costs' | translateWF: 'Without Costs')
                    }}</strong>
                  </label>
                </div>
              </div>
            </form>
          </p-card>
        </p-panel>

        <!-- Report 2: Knitting Work Areas Movement -->
        <p-panel data-tone="surface" [header]="'Reporting_Knitting_Movement_Title' | translateWF: 'Knitting Work Areas Movement'">
          <ng-template pTemplate="icons">
            <p-button
              [label]="'Reporting_Generate_Report' | translateWF: 'Generate Report'"
              icon="pi pi-download"
              (onClick)="generateKnittingMovementReport()"
              [outlined]="true"
              [loading]="loadingKnittingMovement()"
              [disabled]="!knittingMovementForm.valid || isAnyReportLoading()"
            />
          </ng-template>
          <p-card data-variant="flat">
            <p class="report-description">
              {{
                'Reporting_Knitting_Movement_Description'
                  | translateWF
                    : 'Generate movement report for knitting work
              areas within a date range (max 60 days)'
              }}
            </p>
            <form [formGroup]="knittingMovementForm" class="report-form col">
              <div class="grid-12-sm">
                <div class="span-12-6-3 form-box">
                  <label>{{ 'Reporting_Start_Date' | translateWF: 'Start Date' }} *</label>
                  <p-datepicker formControlName="startDate" [iconDisplay]="'input'" [showIcon]="true" dateFormat="yy-mm-dd" fluid class="w-full" />
                </div>
                <div class="span-12-6-3 form-box">
                  <label>{{ 'Reporting_End_Date' | translateWF: 'End Date' }} *</label>
                  <p-datepicker
                    formControlName="endDate"
                    [iconDisplay]="'input'"
                    [showIcon]="true"
                    dateFormat="yy-mm-dd"
                    [maxDate]="knittingMovementMaxDate()"
                    fluid
                    class="w-full"
                  />
                </div>
              </div>
              <div class="report-options" *ngIf="isAdmin">
                <div class="option-toggle">
                  <p-toggle-switch inputId="knitting-movement-costs" formControlName="includeCosts" />
                  <label for="knitting-movement-costs">
                    {{ 'Reporting_Include_Costs' | translateWF: 'Include Costs' }}:
                    <strong>{{
                      knittingMovementForm.value.includeCosts ? ('Reporting_With_Costs' | translateWF: 'With Costs') : ('Reporting_Without_Costs' | translateWF: 'Without Costs')
                    }}</strong>
                  </label>
                </div>
              </div>
            </form>
          </p-card>
        </p-panel>

        <!-- Report 3: Shipment Import -->
        <p-panel data-tone="surface" [header]="'Reporting_Shipment_Import_Title' | translateWF: 'Shipment Import'">
          <ng-template pTemplate="icons">
            <p-button
              [label]="'Reporting_Generate_Report' | translateWF: 'Generate Report'"
              icon="pi pi-download"
              (onClick)="generateShipmentImportReport()"
              [outlined]="true"
              [loading]="loadingShipmentImport()"
              [disabled]="!shipmentImportForm.valid || isAnyReportLoading()"
            />
          </ng-template>
          <p-card data-variant="flat">
            <p class="report-description">
              {{
                'Reporting_Shipment_Import_Description'
                  | translateWF
                    : 'Generate shipment import report for standard or
              consignment shipments (max 60 days)'
              }}
            </p>
            <form [formGroup]="shipmentImportForm" class="report-form col">
              <div class="grid-12-sm">
                <div class="span-12-6-3 form-box">
                  <label>{{ 'Reporting_Start_Date' | translateWF: 'Start Date' }} *</label>
                  <p-datepicker formControlName="startDate" [iconDisplay]="'input'" [showIcon]="true" dateFormat="yy-mm-dd" fluid class="w-full" />
                </div>
                <div class="span-12-6-3 form-box">
                  <label>{{ 'Reporting_End_Date' | translateWF: 'End Date' }} *</label>
                  <p-datepicker
                    formControlName="endDate"
                    [iconDisplay]="'input'"
                    [showIcon]="true"
                    dateFormat="yy-mm-dd"
                    [maxDate]="shipmentImportMaxDate()"
                    fluid
                    class="w-full"
                  />
                </div>
              </div>
              <div class="report-options">
                <div class="option-toggle" *ngIf="isAdmin">
                  <p-toggle-switch inputId="shipment-import-costs" formControlName="includeCosts" />
                  <label for="shipment-import-costs">
                    {{ 'Reporting_Include_Costs' | translateWF: 'Include Costs' }}:
                    <strong>{{
                      shipmentImportForm.value.includeCosts ? ('Reporting_With_Costs' | translateWF: 'With Costs') : ('Reporting_Without_Costs' | translateWF: 'Without Costs')
                    }}</strong>
                  </label>
                </div>
                <div class="option-toggle">
                  <p-toggle-switch inputId="shipment-import-consignment" formControlName="isConsignment" />
                  <label for="shipment-import-consignment">
                    {{ 'Reporting_Consignment' | translateWF: 'Consignment' }}:
                    <strong>{{ shipmentImportForm.value.isConsignment ? ('Reporting_Yes' | translateWF: 'Yes') : ('Reporting_No' | translateWF: 'No') }}</strong>
                  </label>
                </div>
              </div>
            </form>
          </p-card>
        </p-panel>

        <!-- Report 4: Transfer Unit -->
        <p-panel data-tone="surface" [header]="'Reporting_Transfer_Unit_Title' | translateWF: 'Transfer Unit'">
          <ng-template pTemplate="icons">
            <p-button
              [label]="'Reporting_Generate_Report' | translateWF: 'Generate Report'"
              icon="pi pi-download"
              (onClick)="generateTransferUnitReport()"
              [outlined]="true"
              [loading]="loadingTransferUnit()"
              [disabled]="!transferUnitForm.valid || isAnyReportLoading()"
            />
          </ng-template>
          <p-card data-variant="flat">
            <p class="report-description">
              {{
                'Reporting_Transfer_Unit_Description'
                  | translateWF
                    : 'Generate transfer unit report within a date range
              (max 60 days)'
              }}
            </p>
            <form [formGroup]="transferUnitForm" class="report-form col">
              <div class="grid-12-sm">
                <div class="span-12-6-3 form-box">
                  <label for="transfer-unit-start">{{ 'Reporting_Start_Date' | translateWF: 'Start Date' }} *</label>
                  <p-datepicker
                    id="transfer-unit-start"
                    formControlName="startDate"
                    [iconDisplay]="'input'"
                    [showIcon]="true"
                    dateFormat="yy-mm-dd"
                    fluid
                    class="w-full"
                    [ngClass]="{
                      'ng-invalid ng-dirty': transferUnitForm.get('startDate')?.invalid && transferUnitForm.get('startDate')?.touched,
                    }"
                  />
                  <small class="p-error" *ngIf="transferUnitForm.get('startDate')?.invalid && transferUnitForm.get('startDate')?.touched">
                    {{ 'Reporting_Start_Date_Required' | translateWF: 'Start date is required' }}
                  </small>
                </div>

                <div class="span-12-6-3 form-box">
                  <label for="transfer-unit-end">{{ 'Reporting_End_Date' | translateWF: 'End Date' }} *</label>
                  <p-datepicker
                    id="transfer-unit-end"
                    formControlName="endDate"
                    [iconDisplay]="'input'"
                    [showIcon]="true"
                    dateFormat="yy-mm-dd"
                    [maxDate]="transferUnitMaxDate()"
                    fluid
                    class="w-full"
                    [ngClass]="{
                      'ng-invalid ng-dirty': transferUnitForm.get('endDate')?.invalid && transferUnitForm.get('endDate')?.touched,
                    }"
                  />
                  <small class="p-error" *ngIf="transferUnitForm.get('endDate')?.invalid && transferUnitForm.get('endDate')?.touched">
                    {{ 'Reporting_End_Date_Required' | translateWF: 'End date is required' }}
                  </small>
                </div>
              </div>
              <div class="report-options" *ngIf="isAdmin">
                <div class="option-toggle">
                  <p-toggle-switch inputId="transfer-unit-costs" formControlName="includeCosts" />
                  <label for="transfer-unit-costs">
                    {{ 'Reporting_Include_Costs' | translateWF: 'Include Costs' }}:
                    <strong>{{
                      transferUnitForm.value.includeCosts ? ('Reporting_With_Costs' | translateWF: 'With Costs') : ('Reporting_Without_Costs' | translateWF: 'Without Costs')
                    }}</strong>
                  </label>
                </div>
              </div>
            </form>
          </p-card>
        </p-panel>

        <!-- Report 5: Incoming Guatemala Greige -->
        <p-panel data-tone="surface" [header]="'Reporting_Guatemala_Greige_Title' | translateWF: 'Incoming Guatemala Greige'">
          <ng-template pTemplate="icons">
            <p-button
              [label]="'Reporting_Generate_Report' | translateWF: 'Generate Report'"
              icon="pi pi-download"
              (onClick)="generateGuatemalaGreigeReport()"
              [outlined]="true"
              [loading]="loadingGuatemalaGreige()"
              [disabled]="!guatemalaGreigeForm.valid || isAnyReportLoading()"
            />
          </ng-template>
          <p-card data-variant="flat">
            <p class="report-description">
              {{
                'Reporting_Guatemala_Greige_Description'
                  | translateWF
                    : 'Generate incoming Guatemala greige fabric
              report within a date range (max 60 days)'
              }}
            </p>
            <form [formGroup]="guatemalaGreigeForm" class="report-form col">
              <div class="grid-12-sm">
                <div class="span-12-6-3 form-box">
                  <label for="guatemala-greige-start">{{ 'Reporting_Start_Date' | translateWF: 'Start Date' }} *</label>
                  <p-datepicker
                    id="guatemala-greige-start"
                    formControlName="startDate"
                    [iconDisplay]="'input'"
                    [showIcon]="true"
                    dateFormat="yy-mm-dd"
                    fluid
                    class="w-full"
                    [ngClass]="{
                      'ng-invalid ng-dirty': guatemalaGreigeForm.get('startDate')?.invalid && guatemalaGreigeForm.get('startDate')?.touched,
                    }"
                  />
                  <small class="p-error" *ngIf="guatemalaGreigeForm.get('startDate')?.invalid && guatemalaGreigeForm.get('startDate')?.touched">
                    {{ 'Reporting_Start_Date_Required' | translateWF: 'Start date is required' }}
                  </small>
                </div>

                <div class="span-12-6-3 form-box">
                  <label for="guatemala-greige-end">{{ 'Reporting_End_Date' | translateWF: 'End Date' }} *</label>
                  <p-datepicker
                    id="guatemala-greige-end"
                    formControlName="endDate"
                    [iconDisplay]="'input'"
                    [showIcon]="true"
                    dateFormat="yy-mm-dd"
                    [maxDate]="guatemalaGreigeMaxDate()"
                    fluid
                    class="w-full"
                    [ngClass]="{
                      'ng-invalid ng-dirty': guatemalaGreigeForm.get('endDate')?.invalid && guatemalaGreigeForm.get('endDate')?.touched,
                    }"
                  />
                  <small class="p-error" *ngIf="guatemalaGreigeForm.get('endDate')?.invalid && guatemalaGreigeForm.get('endDate')?.touched">
                    {{ 'Reporting_End_Date_Required' | translateWF: 'End date is required' }}
                  </small>
                </div>
              </div>
            </form>
          </p-card>
        </p-panel>

        <!-- Report 5b: Scanned Rolls Not Transferred -->
        <p-panel data-tone="surface" [header]="'Reporting_Pending_Rolls_Title' | translateWF: 'Scanned Rolls Not Transferred'">
          <ng-template pTemplate="icons">
            <p-button
              [label]="'Reporting_Generate_Report' | translateWF: 'Generate Report'"
              icon="pi pi-download"
              (onClick)="generatePendingRollsReport()"
              [outlined]="true"
              [loading]="loadingPendingRolls()"
              [disabled]="!pendingRollsForm.valid || isAnyReportLoading()"
            />
          </ng-template>
          <p-card data-variant="flat">
            <p class="report-description">
              {{
                'Reporting_Pending_Rolls_Description'
                  | translateWF
                    : 'Generate a report of rolls currently in the knitting area that have not been transferred
              yet, grouped by their pending transfer unit'
              }}
            </p>
            <form [formGroup]="pendingRollsForm" class="report-form col">
              <div class="grid-12-sm">
                <div class="span-12-6-3 form-box">
                  <label for="pending-rolls-locations">{{ 'Reporting_Location' | translateWF: 'Location' }} *</label>
                  <p-multiSelect
                    id="pending-rolls-locations"
                    formControlName="locationCodes"
                    [options]="knittingLocations()"
                    optionLabel="label"
                    optionValue="value"
                    [placeholder]="'Reporting_Select_Location' | translateWF: 'Select a location'"
                    appendTo="self"
                    fluid
                    class="w-full"
                    [ngClass]="{
                      'ng-invalid ng-dirty': pendingRollsForm.get('locationCodes')?.invalid && pendingRollsForm.get('locationCodes')?.touched,
                    }"
                  />
                  @if (pendingRollsForm.get('locationCodes')?.invalid && pendingRollsForm.get('locationCodes')?.touched) {
                    <small class="p-error">
                      {{ 'Reporting_Location_Required' | translateWF: 'Location is required' }}
                    </small>
                  }
                </div>
              </div>
            </form>
          </p-card>
        </p-panel>
      </div>
    </p-panel>

    <!-- Panel 3: Supply warehouse -->
    <p-panel [header]="'Supply warehouse'" [toggleable]="true">
      <div class="col-sm">
        <!-- Report 6: Consumable Item Balance (V1 — live balance, kept as it has always worked) -->
        <p-panel data-tone="surface" [header]="'Reporting_Consumable_Balance_Title' | translateWF: 'Consumable Item Balance'">
          <ng-template pTemplate="icons">
            <p-button
              [label]="'Reporting_Generate_Report' | translateWF: 'Generate Report'"
              icon="pi pi-download"
              (onClick)="generateConsumableBalanceReport()"
              [outlined]="true"
              [loading]="loadingConsumableBalance()"
              [disabled]="isAnyReportLoading()"
            />
          </ng-template>
          <p-card data-variant="flat">
            <p class="report-description">
              {{
                'Reporting_Consumable_Balance_Description'
                  | translateWF
                    : 'Generate current inventory balance report
              for consumable items'
              }}
            </p>
          </p-card>
        </p-panel>

        <!-- Report 6a: Consumable Item Balance V2 (as-of-date, 4 sheets) -->
        <p-panel data-tone="surface" [header]="'Reporting_Consumable_Balance_V2_Title' | translateWF: 'Consumable Item Balance V2 (Historical)'">
          <ng-template pTemplate="icons">
            <p-button
              [label]="'Reporting_Generate_Report' | translateWF: 'Generate Report'"
              icon="pi pi-download"
              (onClick)="generateConsumableBalanceV2Report()"
              [outlined]="true"
              [loading]="loadingConsumableBalanceV2()"
              [disabled]="!consumableBalanceForm.valid || isAnyReportLoading()"
            />
          </ng-template>
          <p-card data-variant="flat">
            <p class="report-description">
              {{
                'Reporting_Consumable_Balance_V2_Description'
                  | translateWF
                    : 'New version of the consumable item balance: balance as of a specific date for a
              selected warehouse, in four sheets (INITIAL, IN, OUT, FINAL BALANCE). For a month close use
              Consumable Closed Month Balance below — the accounting month runs to 7:00 AM of the 1st of
              the next month'
              }}
            </p>
            <form [formGroup]="consumableBalanceForm" class="report-form col">
              <div class="grid-12-sm">
                <div class="span-12-6-3 form-box">
                  <label for="consumable-balance-warehouse">{{ 'Reporting_Warehouse' | translateWF: 'Warehouse' }} *</label>
                  <p-select
                    id="consumable-balance-warehouse"
                    formControlName="locationCode"
                    [options]="consumableWarehouses()"
                    optionLabel="label"
                    optionValue="value"
                    [placeholder]="'Reporting_Select_Warehouse' | translateWF: 'Select a warehouse'"
                    fluid
                    class="w-full"
                    [ngClass]="{
                      'ng-invalid ng-dirty': consumableBalanceForm.get('locationCode')?.invalid && consumableBalanceForm.get('locationCode')?.touched,
                    }"
                  />
                  <small class="p-error" *ngIf="consumableBalanceForm.get('locationCode')?.invalid && consumableBalanceForm.get('locationCode')?.touched">
                    {{ 'Reporting_Warehouse_Required' | translateWF: 'Warehouse is required' }}
                  </small>
                </div>

                <div class="span-12-6-3 form-box">
                  <label for="consumable-balance-date">{{ 'Reporting_As_Of_Date' | translateWF: 'As Of Date' }} *</label>
                  <p-datepicker
                    id="consumable-balance-date"
                    formControlName="asOfDate"
                    [iconDisplay]="'input'"
                    [showIcon]="true"
                    [showTime]="true"
                    dateFormat="yy-mm-dd"
                    fluid
                    class="w-full"
                    [ngClass]="{
                      'ng-invalid ng-dirty': consumableBalanceForm.get('asOfDate')?.invalid && consumableBalanceForm.get('asOfDate')?.touched,
                    }"
                  />
                  <small class="p-error" *ngIf="consumableBalanceForm.get('asOfDate')?.invalid && consumableBalanceForm.get('asOfDate')?.touched">
                    {{ 'Reporting_As_Of_Date_Required' | translateWF: 'As of date is required' }}
                  </small>
                </div>
              </div>
            </form>
          </p-card>
        </p-panel>

        <!-- Report 6b: Consumable Closed Month Balance -->
        <p-panel data-tone="surface" [header]="'Reporting_Consumable_Closed_Month_Title' | translateWF: 'Consumable Closed Month Balance'">
          <ng-template pTemplate="icons">
            <p-button
              [label]="'Reporting_Generate_Report' | translateWF: 'Generate Report'"
              icon="pi pi-download"
              (onClick)="generateConsumableClosedMonthReport()"
              [outlined]="true"
              [loading]="loadingConsumableClosedMonth()"
              [disabled]="!consumableClosedMonthForm.valid || isAnyReportLoading()"
            />
          </ng-template>
          <p-card data-variant="flat">
            <p class="report-description">
              {{
                'Reporting_Consumable_Closed_Month_Description'
                  | translateWF
                    : 'Generate detailed consumable balance report
              for a closed month from pre-computed snapshots'
              }}
            </p>
            <form [formGroup]="consumableClosedMonthForm" class="report-form col">
              <div class="grid-12-sm">
                <div class="span-12-6-3 form-box">
                  <label for="consumable-closed-month-warehouse">{{ 'Reporting_Warehouse' | translateWF: 'Warehouse' }} *</label>
                  <p-select
                    id="consumable-closed-month-warehouse"
                    formControlName="locationCode"
                    [options]="consumableWarehouses()"
                    optionLabel="label"
                    optionValue="value"
                    [placeholder]="'Reporting_Select_Warehouse' | translateWF: 'Select a warehouse'"
                    fluid
                    class="w-full"
                    [ngClass]="{
                      'ng-invalid ng-dirty': consumableClosedMonthForm.get('locationCode')?.invalid && consumableClosedMonthForm.get('locationCode')?.touched,
                    }"
                  />
                  <small class="p-error" *ngIf="consumableClosedMonthForm.get('locationCode')?.invalid && consumableClosedMonthForm.get('locationCode')?.touched">
                    {{ 'Reporting_Warehouse_Required' | translateWF: 'Warehouse is required' }}
                  </small>
                </div>

                <div class="span-12-6-3 form-box">
                  <label for="consumable-closed-month-year">{{ 'Reporting_Year' | translateWF: 'Year' }} *</label>
                  <p-select
                    id="consumable-closed-month-year"
                    formControlName="year"
                    [options]="yearOptions"
                    optionLabel="label"
                    optionValue="value"
                    [placeholder]="'Reporting_Select_Year' | translateWF: 'Select year'"
                    fluid
                    class="w-full"
                    [ngClass]="{
                      'ng-invalid ng-dirty': consumableClosedMonthForm.get('year')?.invalid && consumableClosedMonthForm.get('year')?.touched,
                    }"
                  />
                  <small class="p-error" *ngIf="consumableClosedMonthForm.get('year')?.invalid && consumableClosedMonthForm.get('year')?.touched">
                    {{ 'Reporting_Year_Required' | translateWF: 'Year is required' }}
                  </small>
                </div>

                <div class="span-12-6-3 form-box">
                  <label for="consumable-closed-month-month">{{ 'Reporting_Month' | translateWF: 'Month' }} *</label>
                  <p-select
                    id="consumable-closed-month-month"
                    formControlName="month"
                    [options]="monthOptions"
                    optionLabel="label"
                    optionValue="value"
                    [placeholder]="'Reporting_Select_Month' | translateWF: 'Select month'"
                    fluid
                    class="w-full"
                    [ngClass]="{
                      'ng-invalid ng-dirty': consumableClosedMonthForm.get('month')?.invalid && consumableClosedMonthForm.get('month')?.touched,
                    }"
                  />
                  <small class="p-error" *ngIf="consumableClosedMonthForm.get('month')?.invalid && consumableClosedMonthForm.get('month')?.touched">
                    {{ 'Reporting_Month_Required' | translateWF: 'Month is required' }}
                  </small>
                </div>
              </div>
            </form>
          </p-card>
        </p-panel>

        <!-- Report 7: Consumable Inbound -->
        <p-panel data-tone="surface" [header]="'Reporting_Consumable_Inbound_Title' | translateWF: 'Consumable Inbound Movement'">
          <ng-template pTemplate="icons">
            <p-button
              [label]="'Reporting_Generate_Report' | translateWF: 'Generate Report'"
              icon="pi pi-download"
              (onClick)="generateConsumableInboundReport()"
              [outlined]="true"
              [loading]="loadingConsumableInbound()"
              [disabled]="!consumableInboundForm.valid || isAnyReportLoading()"
            />
          </ng-template>
          <p-card data-variant="flat">
            <p class="report-description">
              {{
                'Reporting_Consumable_Inbound_Description'
                  | translateWF
                    : 'Generate consumable inbound movement report (Goods Receipt Notes) within a date range (max
              60 days)'
              }}
            </p>
            <form [formGroup]="consumableInboundForm" class="report-form col">
              <div class="grid-12-sm">
                <div class="span-12-6-3 form-box">
                  <label for="consumable-inbound-warehouse">{{ 'Reporting_Warehouse' | translateWF: 'Warehouse' }} *</label>
                  <p-select
                    id="consumable-inbound-warehouse"
                    formControlName="locationCode"
                    [options]="consumableWarehouses()"
                    optionLabel="label"
                    optionValue="value"
                    [placeholder]="'Reporting_Select_Warehouse' | translateWF: 'Select a warehouse'"
                    fluid
                    class="w-full"
                    [ngClass]="{
                      'ng-invalid ng-dirty': consumableInboundForm.get('locationCode')?.invalid && consumableInboundForm.get('locationCode')?.touched,
                    }"
                  />
                  <small class="p-error" *ngIf="consumableInboundForm.get('locationCode')?.invalid && consumableInboundForm.get('locationCode')?.touched">
                    {{ 'Reporting_Warehouse_Required' | translateWF: 'Warehouse is required' }}
                  </small>
                </div>

                <div class="span-12-6-3 form-box">
                  <label for="consumable-inbound-start">{{ 'Reporting_Start_Date' | translateWF: 'Start Date' }} *</label>
                  <p-datepicker
                    id="consumable-inbound-start"
                    formControlName="startDate"
                    [iconDisplay]="'input'"
                    [showIcon]="true"
                    dateFormat="yy-mm-dd"
                    fluid
                    class="w-full"
                    [ngClass]="{
                      'ng-invalid ng-dirty': consumableInboundForm.get('startDate')?.invalid && consumableInboundForm.get('startDate')?.touched,
                    }"
                  />
                  <small class="p-error" *ngIf="consumableInboundForm.get('startDate')?.invalid && consumableInboundForm.get('startDate')?.touched">
                    {{ 'Reporting_Start_Date_Required' | translateWF: 'Start date is required' }}
                  </small>
                </div>

                <div class="span-12-6-3 form-box">
                  <label for="consumable-inbound-end">{{ 'Reporting_End_Date' | translateWF: 'End Date' }} *</label>
                  <p-datepicker
                    id="consumable-inbound-end"
                    formControlName="endDate"
                    [iconDisplay]="'input'"
                    [showIcon]="true"
                    dateFormat="yy-mm-dd"
                    [maxDate]="consumableInboundMaxDate()"
                    fluid
                    class="w-full"
                    [ngClass]="{
                      'ng-invalid ng-dirty': consumableInboundForm.get('endDate')?.invalid && consumableInboundForm.get('endDate')?.touched,
                    }"
                  />
                  <small class="p-error" *ngIf="consumableInboundForm.get('endDate')?.invalid && consumableInboundForm.get('endDate')?.touched">
                    {{ 'Reporting_End_Date_Required' | translateWF: 'End date is required' }}
                  </small>
                </div>
              </div>
            </form>
          </p-card>
        </p-panel>

        <!-- Report 8: Consumable Outbound -->
        <p-panel data-tone="surface" [header]="'Reporting_Consumable_Outbound_Title' | translateWF: 'Consumable Outbound Movement'">
          <ng-template pTemplate="icons">
            <p-button
              [label]="'Reporting_Generate_Report' | translateWF: 'Generate Report'"
              icon="pi pi-download"
              (onClick)="generateConsumableOutboundReport()"
              [outlined]="true"
              [loading]="loadingConsumableOutbound()"
              [disabled]="!consumableOutboundForm.valid || isAnyReportLoading()"
            />
          </ng-template>
          <p-card data-variant="flat">
            <p class="report-description">
              {{
                'Reporting_Consumable_Outbound_Description'
                  | translateWF
                    : 'Generate consumable outbound movement report (Dispatch Requests and Material Issues)
              within a date range (max 60 days)'
              }}
            </p>
            <form [formGroup]="consumableOutboundForm" class="report-form col">
              <div class="grid-12-sm">
                <div class="span-12-6-3 form-box">
                  <label for="consumable-outbound-warehouse">{{ 'Reporting_Warehouse' | translateWF: 'Warehouse' }} *</label>
                  <p-select
                    id="consumable-outbound-warehouse"
                    formControlName="locationCode"
                    [options]="consumableWarehouses()"
                    optionLabel="label"
                    optionValue="value"
                    [placeholder]="'Reporting_Select_Warehouse' | translateWF: 'Select a warehouse'"
                    fluid
                    class="w-full"
                    [ngClass]="{
                      'ng-invalid ng-dirty': consumableOutboundForm.get('locationCode')?.invalid && consumableOutboundForm.get('locationCode')?.touched,
                    }"
                  />
                  <small class="p-error" *ngIf="consumableOutboundForm.get('locationCode')?.invalid && consumableOutboundForm.get('locationCode')?.touched">
                    {{ 'Reporting_Warehouse_Required' | translateWF: 'Warehouse is required' }}
                  </small>
                </div>

                <div class="span-12-6-3 form-box">
                  <label for="consumable-outbound-start">{{ 'Reporting_Start_Date' | translateWF: 'Start Date' }} *</label>
                  <p-datepicker
                    id="consumable-outbound-start"
                    formControlName="startDate"
                    [iconDisplay]="'input'"
                    [showIcon]="true"
                    dateFormat="yy-mm-dd"
                    fluid
                    class="w-full"
                    [ngClass]="{
                      'ng-invalid ng-dirty': consumableOutboundForm.get('startDate')?.invalid && consumableOutboundForm.get('startDate')?.touched,
                    }"
                  />
                  <small class="p-error" *ngIf="consumableOutboundForm.get('startDate')?.invalid && consumableOutboundForm.get('startDate')?.touched">
                    {{ 'Reporting_Start_Date_Required' | translateWF: 'Start date is required' }}
                  </small>
                </div>

                <div class="span-12-6-3 form-box">
                  <label for="consumable-outbound-end">{{ 'Reporting_End_Date' | translateWF: 'End Date' }} *</label>
                  <p-datepicker
                    id="consumable-outbound-end"
                    formControlName="endDate"
                    [iconDisplay]="'input'"
                    [showIcon]="true"
                    dateFormat="yy-mm-dd"
                    [maxDate]="consumableOutboundMaxDate()"
                    fluid
                    class="w-full"
                    [ngClass]="{
                      'ng-invalid ng-dirty': consumableOutboundForm.get('endDate')?.invalid && consumableOutboundForm.get('endDate')?.touched,
                    }"
                  />
                  <small class="p-error" *ngIf="consumableOutboundForm.get('endDate')?.invalid && consumableOutboundForm.get('endDate')?.touched">
                    {{ 'Reporting_End_Date_Required' | translateWF: 'End date is required' }}
                  </small>
                </div>
              </div>
            </form>
          </p-card>
        </p-panel>

        <!-- Report 8b: Consumable Balance Audit -->
        <p-panel data-tone="surface" [header]="'Reporting_Consumable_Balance_Audit_Title' | translateWF: 'Consumable Balance Audit'">
          <ng-template pTemplate="icons">
            <p-button
              [label]="'Reporting_Generate_Report' | translateWF: 'Generate Report'"
              icon="pi pi-download"
              (onClick)="generateConsumableBalanceAuditReport()"
              [outlined]="true"
              [loading]="loadingBalanceAudit()"
              [disabled]="!balanceAuditForm.valid || balanceAuditSelectedItems.length === 0 || isAnyReportLoading()"
            />
          </ng-template>
          <p-card data-variant="flat">
            <p class="report-description">
              {{
                'Reporting_Consumable_Balance_Audit_Description'
                  | translateWF
                    : 'Generate consumable balance audit
              report for a specific warehouse and selected items'
              }}
            </p>
            <form [formGroup]="balanceAuditForm" class="report-form col">
              <div class="grid-12-sm">
                <div class="span-12-6-3 form-box">
                  <label for="balance-audit-items">{{ 'Reporting_Items' | translateWF: 'Items' }} *</label>
                  <p-multiSelect
                    id="balance-audit-items"
                    [options]="balanceAuditItems()"
                    [(ngModel)]="balanceAuditSelectedItems"
                    [ngModelOptions]="{ standalone: true }"
                    optionLabel="label"
                    optionValue="value"
                    [placeholder]="'Reporting_Select_Items' | translateWF: 'Select items'"
                    [filter]="true"
                    (onFilter)="onBalanceAuditItemSearch($event)"
                    appendTo="self"
                    fluid
                    class="w-full"
                  />
                </div>
                <div class="span-12-6-3 form-box">
                  <label for="balance-audit-warehouse">{{ 'Reporting_Warehouse' | translateWF: 'Warehouse' }} *</label>
                  <p-select
                    id="balance-audit-warehouse"
                    formControlName="locationCode"
                    [options]="consumableWarehouses()"
                    optionLabel="label"
                    optionValue="value"
                    [placeholder]="'Reporting_Select_Warehouse' | translateWF: 'Select a warehouse'"
                    fluid
                    class="w-full"
                    [ngClass]="{
                      'ng-invalid ng-dirty': balanceAuditForm.get('locationCode')?.invalid && balanceAuditForm.get('locationCode')?.touched,
                    }"
                  />
                  <small class="p-error" *ngIf="balanceAuditForm.get('locationCode')?.invalid && balanceAuditForm.get('locationCode')?.touched">
                    {{ 'Reporting_Warehouse_Required' | translateWF: 'Warehouse is required' }}
                  </small>
                </div>
              </div>
            </form>
          </p-card>
        </p-panel>
      </div>
    </p-panel>

    <!-- Panel 4: Inventories by locations -->
    <p-panel [header]="'Inventories by locations'" [toggleable]="true">
      <div class="col-sm">
        <!-- Report 9: Warehouse Movement -->
        <p-panel data-tone="surface" [header]="'Reporting_Warehouse_Movement_Title' | translateWF: 'Warehouse Movement'">
          <ng-template pTemplate="icons">
            <p-button
              [label]="'Reporting_Generate_Report' | translateWF: 'Generate Report'"
              icon="pi pi-download"
              (onClick)="generateWarehouseMovementReport()"
              [outlined]="true"
              [loading]="loadingWarehouseMovement()"
              [disabled]="!warehouseMovementForm.valid || isAnyReportLoading()"
            />
          </ng-template>
          <p-card data-variant="flat">
            <p class="report-description">
              {{
                'Reporting_Warehouse_Movement_Description'
                  | translateWF
                    : 'Generate warehouse movement report for a specific location within a date range (max 60
              days)'
              }}
            </p>
            <form [formGroup]="warehouseMovementForm" class="report-form col">
              <div class="grid-12-sm">
                <div class="span-12-6-3 form-box">
                  <label for="warehouse-movement-location">{{ 'Reporting_Location' | translateWF: 'Location' }} *</label>
                  <p-select
                    id="warehouse-movement-location"
                    formControlName="locationCode"
                    [options]="warehouseLocations()"
                    optionLabel="label"
                    optionValue="value"
                    [placeholder]="'Reporting_Select_Location' | translateWF: 'Select a location'"
                    fluid
                    class="w-full"
                    [ngClass]="{
                      'ng-invalid ng-dirty': warehouseMovementForm.get('locationCode')?.invalid && warehouseMovementForm.get('locationCode')?.touched,
                    }"
                  />
                  <small class="p-error" *ngIf="warehouseMovementForm.get('locationCode')?.invalid && warehouseMovementForm.get('locationCode')?.touched">
                    {{ 'Reporting_Location_Required' | translateWF: 'Location is required' }}
                  </small>
                </div>

                <div class="span-12-6-3 form-box">
                  <label for="warehouse-movement-start">{{ 'Reporting_Start_Date' | translateWF: 'Start Date' }} *</label>
                  <p-datepicker
                    id="warehouse-movement-start"
                    formControlName="startDate"
                    [iconDisplay]="'input'"
                    [showIcon]="true"
                    [showTime]="true"
                    dateFormat="yy-mm-dd"
                    fluid
                    class="w-full"
                    [ngClass]="{
                      'ng-invalid ng-dirty': warehouseMovementForm.get('startDate')?.invalid && warehouseMovementForm.get('startDate')?.touched,
                    }"
                  />
                  <small class="p-error" *ngIf="warehouseMovementForm.get('startDate')?.invalid && warehouseMovementForm.get('startDate')?.touched">
                    {{ 'Reporting_Start_Date_Required' | translateWF: 'Start date is required' }}
                  </small>
                </div>

                <div class="span-12-6-3 form-box">
                  <label for="warehouse-movement-end">{{ 'Reporting_End_Date' | translateWF: 'End Date' }} *</label>
                  <p-datepicker
                    id="warehouse-movement-end"
                    formControlName="endDate"
                    [iconDisplay]="'input'"
                    [showIcon]="true"
                    [showTime]="true"
                    dateFormat="yy-mm-dd"
                    [maxDate]="warehouseMovementMaxDate()"
                    fluid
                    class="w-full"
                    [ngClass]="{
                      'ng-invalid ng-dirty': warehouseMovementForm.get('endDate')?.invalid && warehouseMovementForm.get('endDate')?.touched,
                    }"
                  />
                  <small class="p-error" *ngIf="warehouseMovementForm.get('endDate')?.invalid && warehouseMovementForm.get('endDate')?.touched">
                    {{ 'Reporting_End_Date_Required' | translateWF: 'End date is required' }}
                  </small>
                </div>
              </div>
            </form>
          </p-card>
        </p-panel>

        <!-- Report 10: Historical Inventory Balance -->
        <p-panel data-tone="surface" [header]="'Reporting_Historical_Balance_Title' | translateWF: 'Historical Inventory Balance'">
          <ng-template pTemplate="icons">
            <p-button
              [label]="'Reporting_Generate_Report' | translateWF: 'Generate Report'"
              icon="pi pi-download"
              (onClick)="generateHistoricalBalanceReport()"
              [outlined]="true"
              [loading]="loadingHistoricalBalance()"
              [disabled]="!historicalBalanceForm.valid || isAnyReportLoading()"
            />
          </ng-template>
          <p-card data-variant="flat">
            <p class="report-description">
              {{
                'Reporting_Historical_Balance_Description'
                  | translateWF
                    : 'Generate detailed inventory balance report (INITIAL, IN, OUT, CURRENT) for a specific
              warehouse location as of a given date'
              }}
            </p>
            <form [formGroup]="historicalBalanceForm" class="report-form col">
              <div class="grid-12-sm">
                <div class="span-12-6-3 form-box">
                  <label for="historical-balance-location">{{ 'Reporting_Location' | translateWF: 'Location' }} *</label>
                  <p-select
                    id="historical-balance-location"
                    formControlName="locationCode"
                    [options]="balanceLocations()"
                    optionLabel="label"
                    optionValue="value"
                    [placeholder]="'Reporting_Select_Location' | translateWF: 'Select a location'"
                    fluid
                    class="w-full"
                    [ngClass]="{
                      'ng-invalid ng-dirty': historicalBalanceForm.get('locationCode')?.invalid && historicalBalanceForm.get('locationCode')?.touched,
                    }"
                  >
                    <ng-template let-location pTemplate="selectedItem">
                      <span *ngIf="location"
                        >{{ location.label }} <small class="text-gray-500">({{ location.value }})</small>
                        @if (location.isExitLocation) {
                          <small class="text-gray-500">· {{ 'Reporting_Exit_Location_Movement' | translateWF: 'movement for the period' }}</small>
                        }
                      </span>
                    </ng-template>
                    <ng-template let-location pTemplate="item">
                      <div class="col">
                        <span>{{ location.label }}</span>
                        <small class="text-gray-500">{{ location.value }}</small>
                        @if (location.isExitLocation) {
                          <small class="text-gray-500">{{ 'Reporting_Exit_Location_Movement' | translateWF: 'movement for the period' }}</small>
                        }
                      </div>
                    </ng-template>
                  </p-select>
                  <small class="p-error" *ngIf="historicalBalanceForm.get('locationCode')?.invalid && historicalBalanceForm.get('locationCode')?.touched">
                    {{ 'Reporting_Location_Required' | translateWF: 'Location is required' }}
                  </small>
                </div>

                <div class="span-12-6-3 form-box">
                  <label for="historical-balance-date">{{ 'Reporting_As_Of_Date' | translateWF: 'As Of Date' }} *</label>
                  <p-datepicker
                    id="historical-balance-date"
                    formControlName="asOfDate"
                    [iconDisplay]="'input'"
                    [showIcon]="true"
                    [showTime]="true"
                    dateFormat="yy-mm-dd"
                    fluid
                    class="w-full"
                    [ngClass]="{
                      'ng-invalid ng-dirty': historicalBalanceForm.get('asOfDate')?.invalid && historicalBalanceForm.get('asOfDate')?.touched,
                    }"
                  />
                  <small class="p-error" *ngIf="historicalBalanceForm.get('asOfDate')?.invalid && historicalBalanceForm.get('asOfDate')?.touched">
                    {{ 'Reporting_As_Of_Date_Required' | translateWF: 'As of date is required' }}
                  </small>
                </div>
              </div>
              <div class="report-options mb-4" *ngIf="canViewCost">
                <div class="option-toggle">
                  <p-toggle-switch inputId="historical-balance-cost" formControlName="includeCost" />
                  <label for="historical-balance-cost">
                    {{ 'Reporting_Include_Costs' | translateWF: 'Include Costs' }}:
                    <strong>{{
                      historicalBalanceForm.value.includeCost ? ('Reporting_With_Costs' | translateWF: 'With Costs') : ('Reporting_Without_Costs' | translateWF: 'Without Costs')
                    }}</strong>
                  </label>
                </div>
              </div>
            </form>
          </p-card>
        </p-panel>

        <!-- Report 11: Closed Month Balance -->
        <p-panel data-tone="surface" [header]="'Reporting_Closed_Month_Balance_Title' | translateWF: 'Closed Month Balance'">
          <ng-template pTemplate="icons">
            <p-button
              [label]="'Reporting_Generate_Report' | translateWF: 'Generate Report'"
              icon="pi pi-download"
              (onClick)="generateClosedMonthBalanceReport()"
              [outlined]="true"
              [loading]="loadingClosedMonthBalance()"
              [disabled]="!closedMonthBalanceForm.valid || isAnyReportLoading()"
            />
          </ng-template>
          <p-card data-variant="flat">
            <p class="report-description">
              {{
                'Reporting_Closed_Month_Balance_Description'
                  | translateWF
                    : 'Generate detailed inventory balance report
              for a closed month from pre-computed snapshots'
              }}
            </p>
            <form [formGroup]="closedMonthBalanceForm" class="report-form col">
              <div class="grid-12-sm">
                <div class="span-12-6-3 form-box">
                  <label for="closed-month-location">{{ 'Reporting_Location' | translateWF: 'Location' }} *</label>
                  <p-select
                    id="closed-month-location"
                    formControlName="locationCode"
                    [options]="balanceLocations()"
                    optionLabel="label"
                    optionValue="value"
                    [placeholder]="'Reporting_Select_Location' | translateWF: 'Select a location'"
                    fluid
                    class="w-full"
                    [ngClass]="{
                      'ng-invalid ng-dirty': closedMonthBalanceForm.get('locationCode')?.invalid && closedMonthBalanceForm.get('locationCode')?.touched,
                    }"
                  >
                    <ng-template let-location pTemplate="selectedItem">
                      <span *ngIf="location"
                        >{{ location.label }} <small class="text-gray-500">({{ location.value }})</small>
                        @if (location.isExitLocation) {
                          <small class="text-gray-500">· {{ 'Reporting_Exit_Location_Movement' | translateWF: 'movement for the period' }}</small>
                        }
                      </span>
                    </ng-template>
                    <ng-template let-location pTemplate="item">
                      <div class="col">
                        <span>{{ location.label }}</span>
                        <small class="text-gray-500">{{ location.value }}</small>
                        @if (location.isExitLocation) {
                          <small class="text-gray-500">{{ 'Reporting_Exit_Location_Movement' | translateWF: 'movement for the period' }}</small>
                        }
                      </div>
                    </ng-template>
                  </p-select>
                  <small class="p-error" *ngIf="closedMonthBalanceForm.get('locationCode')?.invalid && closedMonthBalanceForm.get('locationCode')?.touched">
                    {{ 'Reporting_Location_Required' | translateWF: 'Location is required' }}
                  </small>
                </div>

                <div class="span-12-6-3 form-box">
                  <label for="closed-month-year">{{ 'Reporting_Year' | translateWF: 'Year' }} *</label>
                  <p-select
                    id="closed-month-year"
                    formControlName="year"
                    [options]="yearOptions"
                    optionLabel="label"
                    optionValue="value"
                    [placeholder]="'Reporting_Select_Year' | translateWF: 'Select year'"
                    fluid
                    class="w-full"
                    [ngClass]="{
                      'ng-invalid ng-dirty': closedMonthBalanceForm.get('year')?.invalid && closedMonthBalanceForm.get('year')?.touched,
                    }"
                  />
                  <small class="p-error" *ngIf="closedMonthBalanceForm.get('year')?.invalid && closedMonthBalanceForm.get('year')?.touched">
                    {{ 'Reporting_Year_Required' | translateWF: 'Year is required' }}
                  </small>
                </div>

                <div class="span-12-6-3 form-box">
                  <label for="closed-month-month">{{ 'Reporting_Month' | translateWF: 'Month' }} *</label>
                  <p-select
                    id="closed-month-month"
                    formControlName="month"
                    [options]="monthOptions"
                    optionLabel="label"
                    optionValue="value"
                    [placeholder]="'Reporting_Select_Month' | translateWF: 'Select month'"
                    fluid
                    class="w-full"
                    [ngClass]="{
                      'ng-invalid ng-dirty': closedMonthBalanceForm.get('month')?.invalid && closedMonthBalanceForm.get('month')?.touched,
                    }"
                  />
                  <small class="p-error" *ngIf="closedMonthBalanceForm.get('month')?.invalid && closedMonthBalanceForm.get('month')?.touched">
                    {{ 'Reporting_Month_Required' | translateWF: 'Month is required' }}
                  </small>
                </div>
              </div>
              <div class="report-options mb-4" *ngIf="canViewCost">
                <div class="option-toggle">
                  <p-toggle-switch inputId="closed-month-cost" formControlName="includeCost" />
                  <label for="closed-month-cost">
                    {{ 'Reporting_Include_Costs' | translateWF: 'Include Costs' }}:
                    <strong>{{
                      closedMonthBalanceForm.value.includeCost ? ('Reporting_With_Costs' | translateWF: 'With Costs') : ('Reporting_Without_Costs' | translateWF: 'Without Costs')
                    }}</strong>
                  </label>
                </div>
              </div>
            </form>
          </p-card>
        </p-panel>
      </div>
    </p-panel>
  </div>
</main>
